<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="4">
        <v-card class="mb-3">
          <v-card-title>Total en efectivo</v-card-title>
          <v-card-text>
            <span style="font-size: 1.5em; font-weight: bold;">
              ${{ desglose.pagos_membresias_efectivo.toLocaleString('es-CO') }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="mb-3">
          <v-card-title>Total en transferencia</v-card-title>
          <v-card-text>
            <span style="font-size: 1.5em; font-weight: bold;">
              ${{ desglose.pagos_membresias_transferencia.toLocaleString('es-CO') }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="mb-3">
          <v-card-title>Total ventas productos</v-card-title>
          <v-card-text>
            <span style="font-size: 1.5em; font-weight: bold;">
              ${{ desglose.ventas_productos.toLocaleString('es-CO') }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <ajuste-caja-form :monto-registrado="montoRegistrado" :usuario="usuario" @ajuste-registrado="actualizarHistorial" />
    <v-divider class="my-5"></v-divider>
    <historial-ajustes-caja ref="historial" />
  </v-container>
</template>

<script>
import AjusteCajaForm from './AjusteCajaForm.vue';
import HistorialAjustesCaja from './HistorialAjustesCaja.vue';
import Utiles from '../../Servicios/Utiles';

export default {
  name: 'Caja',
  components: {
    AjusteCajaForm,
    HistorialAjustesCaja
  },
  data() {
    return {
      montoRegistrado: 0,
      desglose: {
        pagos_membresias_efectivo: 0,
        pagos_membresias_transferencia: 0,
        ventas_productos: 0
      },
      usuario: localStorage.getItem('nombreUsuario') || ''
    };
  },
  mounted() {
    this.obtenerMontoRegistrado();
  },
  methods: {
    async obtenerMontoRegistrado() {
      try {
        const res = await fetch(Utiles.generarURL('calcular_monto_registrado.php'));
        const data = await res.json();
        if (data.exito) {
          this.montoRegistrado = data.monto_registrado;
          this.desglose = data.desglose || this.desglose;
        } else {
          console.error('Error al obtener monto registrado:', data.mensaje);
          this.montoRegistrado = 0;
          this.desglose = {
            pagos_membresias_efectivo: 0,
            pagos_membresias_transferencia: 0,
            ventas_productos: 0
          };
        }
      } catch (e) {
        console.error('Error de conexión al obtener monto registrado:', e);
        this.montoRegistrado = 0;
        this.desglose = {
          pagos_membresias_efectivo: 0,
          pagos_membresias_transferencia: 0,
          ventas_productos: 0
        };
      }
    },
    actualizarHistorial() {
      this.$refs.historial.cargarHistorial();
    }
  }
};
</script> 


// WEBPACK FOOTER //
// src/components/Caja/Caja.vue